import i18n from 'scoreboard/components/i18n'
import ChartSortTypes from 'scoreboard/charts/model/chart-sort-types'
const { MANUAL, BY_LABEL, BY_VALUE } = ChartSortTypes

/**
 * Returns the text describing the direction of the sorting, such as
 * "A to Z" or "High to Low"
 *
 * @param {ChartSortType} sortType
 * @param {ChartSortDirection} direction
 *
 * @returns {String} localized message
 */
function directionText ({ sortType, direction }) {
	let code
	if (sortType && sortType != MANUAL) {
		code = 'common.search.sort.'
		if (sortType === BY_VALUE) {
			code += 'number.'
		} else if (sortType === BY_LABEL) {
			code += 'alpha.'
		}

		code += direction === 'descending'
			? 'desc' : 'asc'
	}

	return code ? i18n.get(code) : null
}

export default directionText

directionText.__filename__ = 'charts/edit/sort/direction-text.js'
